import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';
import { CircularProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import ReactDropzone from 'react-dropzone';
import { Grid } from '@material-ui/core';
import Card, { CardContent } from 'material-ui/Card';
import Remove from '@material-ui/icons/Close';
import { MenuItem } from 'material-ui/Menu';
import getEnvironmentFromUrl from '../../helpers/GetEnvironment';
import optional from '../../helpers/OptionalAccess';
import RenderDialog from '../../helpers/RenderDialog';
import renderSelectField from '../../helpers/RenderSelectField';

import getReportTypes from '../../actions/getReportTypes';
import postPresignedUrl from '../../actions/postPresignedUrl';
import searchByAttribute from '../../actions/searchByAttribute';
import postUrlFileUpload from '../../actions/postUrlFileUpload';
import upload from '../../images/upload.png';

import Layout from '../Layout';
import validationHelper from '../../helpers/ValidationHelper';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
    height: '630px'
  },
  reportSelector: {
    display: 'flex',
    margin: '0 auto'
  },
  dropBoxArea: {
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'column',
    justifyContent: 'space-evenly'
  },
  paperStyle: {
    width: '70%',
    height: '70%',
    display: 'inline-block',
    marginTop: '5.4vh',
    maxWidth: '1075px',
    minHeight: '676px',
    marginBottom: '4vh'
  },
  buttonStyle: {
    marginTop: '20px'
  },
  messageStyle: {
    padding: '10px 0'
  },
  '@media screen and (max-width: 1130px)': {
    buttonStyle: {
      flexWrap: 'wrap',
      textAlign: 'center'
    },
  },
  '@media screen and (max-width: 600px)': {
    buttonStyle: {
      width: '30%',
      marginLeft: '33%'
    },
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 200,
    paddingBottom: '7px'
  },
  scoreModel: {
    width: 120,
    fontSize: '9pt',
    padding: 0,
    margin: 0,
    verticalAlign: 'top'
  },
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
  },
  headerTitleStyle: {
    flexDirection: 'column',
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto'
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  alertClass: {
    border: '1px solid',
    borderColor: 'red',
    borderRadius: '10px',
  },
  centerMsg: {
    textAlign: 'center',
    color: 'red',
  },
  menuDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginLeft: '50%',
    paddingTop: '5%'
  },
  chip: {
    margin: theme.spacing.unit / 2,
    minWidth: '200px'
  },
  listOfReports: {
    listStyle: 'none',
    borderBottom: '1px solid rgba(168, 169, 174, 1)',
    textAlign: 'left',
    padding: '0px 40px 5px',
    color: 'rgba(168, 169, 174, 1)',
    marginTop: '0px'
  },
  aciListOfReports: {
    padding: '0px',
    borderBottom: 'none',
    color: 'rgba(168, 169, 174, 1)',
    textAlign: 'left',
    listStyle: 'none'
  },
  availableReportHeader: {
    width: '100%',
    font: 'Roboto',
    fontSize: '16pt',
    padding: '0',
    margin: '0',
    color: 'rgba(168, 169, 174, 1)',
    borderBottom: '1px solid rgba(168, 169, 174, 1)'
  },
  availabeReportDiv: {
    textAlign: 'center',
    margin: 'auto',
    color: 'grey',
    paddingTop: '10px'
  },
  dropBoxMessage: {
    fontSize: '18pt'
  },
  dropBoxMessageSpan: {
    color: '#002053',
    cursor: 'pointer'
  },
  reportToRunDiv: {
    width: '300px',
    margin: '0 auto'
  },
  formDiv: {
    paddingTop: '7%'
  },
  reportInstructions: {
    color: 'royalblue',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '12px',
    padding: '2 0 0 0'
  }
});

const validate = (values) => {
  const fieldsToValidate = ['Risk Predictor Score', 'Risk Plus Score']
  if (sessionStorage.product === 'AutoCheck Auctions') fieldsToValidate.push('responseFormat')

  const errors = validationHelper.validateRequired(fieldsToValidate, values);
  return errors;
};
class MultipleVINReport extends Component {
  constructor() {
    super();

    this.state = {
      custReportData: [],
      isFetching: true,
      products: { 'AutoCheck Auctions': 'ACA', 'AutoCheck Insurance': 'ACI', 'VIN Cross Check': 'VXC' },
      filesToUpload: [],
      reportFormat: 'HTML',
      fileUploadedMessage: '',
      fileUploaded: false,
      message: '',
      openDialog: false,
      predictorScoreModel: '',
      plusScoreModel: '',
      fileAttached: false,
      cont: false
    };
    this.onlyCsv= false;
  }

  componentDidMount() {
    this.props.actions.getPageData(this.props.data.config, this);
  }


  onDrop = (acceptedFiles) => {
    let fileName = acceptedFiles[0].name.replace(/[^\w.-]/g, '');

    Object.defineProperty(acceptedFiles[0], 'name', { writeable: true, value: fileName });

    const fileExt = fileName.substr(fileName.length - 4, 4);
    if (fileExt.toLowerCase() !== '.csv' && fileExt.toLowerCase() !== '.txt') {
      this.setState({ fileUploadedMessage: '', fileAttached: false, openDialog: true, message: 'The file uploaded isn\'t valid for submission.  Please make sure the file type is either .csv or .txt, then try again.' });
    } else {
      this.handleFormatCheck(acceptedFiles);
    }
  };

  handleFormatCheck = (acceptedFiles) => {
    const reader = new FileReader();

    reader.onload = () => {
      const fileContent = reader.result.trim();
      if (reader.result.trim().split(new RegExp('[,\n]'))[0].toLowerCase().trim() !== 'vin') {
        this.setState({ fileUploadedMessage: '', fileAttached: false, openDialog: true, message: 'The uploaded file must contain a column header called vin.' });
      } else if (validationHelper.validateFileContent(fileContent.replace(/(?:\r\n|\r|\n)/g, ' '))) {
        this.setState({ fileUploadedMessage: '', fileAttached: false, openDialog: true, message: 'The file submitted contains invalid characters and cannot be processed. Please check the formatting and resubmit. Thank you.' });
      } else {
        this.setState({ cont: true }, () => {
          this.fileIsValid(acceptedFiles);
        });
      }
    }

    acceptedFiles.forEach(file => reader.readAsBinaryString(file));
  }

  fileIsValid(acceptedFiles) {
    if (this.state.cont) {
      this.setState(() => {
        const files = [acceptedFiles];
        return { fileAttached: true, message: '', filesToUpload: files, fileUploadedMessage: (<p style={{ marginBottom: '5%' }}><span style={{ color: '#002053' }}>{acceptedFiles[0].name}</span> is ready for upload</p>) };
      });
    }
  }

  handleDelete = (reportUrl) => {
    this.setState({
      custReportData: this.state.custReportData.filter(report => report !== reportUrl)
    });
  }

  handleClose = () => {
    this.setState({ openDialog: false });
  }

  handleSave = (e) => {
    e.preventDefault();
    const { personId } = this.props.data;
    const { autotecId } = this.props;
    const reports = [];
    const { products, reportFormat } = this.state;

    if (this.props.data.reportTypes &&
      this.props.data.reportTypes.reportTypes &&
      this.props.data.reportTypes.reportTypes.reportTypes) {
      this.props.data.reportTypes.reportTypes.reportTypes.forEach((rep) => {
        if (this.state.custReportData.includes(rep.methodId)
          && rep.enum !== 'NMVTIS'
          && rep.productType.includes(products[sessionStorage.getItem('product')])) {
          if (rep.productType.includes('ACA') && rep.enum !== 'VEHICLE_HISTORY') {
            reports.push(rep.enum);
          } else if (rep.productType.includes('ACI')) {
            reports.push(rep.enum);
          }
        }
      });
    }

    if (reports.indexOf('SUMMARY') !== -1) reports.splice(reports.indexOf('SUMMARY'), 1);
    if (reportFormat === 'HTML' && reports.indexOf('DATA_EXISTS') !== -1) reports.splice(reports.indexOf('DATA_EXISTS'), 1);
    if (reportFormat === 'HTML' && reports.indexOf('FIRST_LAST') !== -1) reports.splice(reports.indexOf('FIRST_LAST'), 1);

    const reportString = reports.join(',');
    const keyString = `${autotecId}/${personId}/${Date.now()}_${this.state.filesToUpload[0][0].name}`;
    if (sessionStorage.getItem('product') === 'AutoCheck Auctions') {

      const fields = {
        'x-amz-meta-reports': reportString,
        'x-amz-meta-autotecId': autotecId,
        'x-amz-meta-locationId': localStorage.getItem('locationId'),
        'x-amz-meta-customerId': this.props.data.customerInfo.customerId,
        'x-amz-meta-outputType': this.onlyCsv ? 'CSV' : this.state.reportFormat,
        'x-amz-meta-customerName': this.props.data.customerInfo.name,
        'x-amz-meta-personId': this.props.data.person.personId
      }

      const params = {
        bucket: `autotec-${getEnvironmentFromUrl()}-multiple-vin-in`,
        method: 'POST',
        fields
      }


      this.props.actions.postUrlFile(this.state.filesToUpload[0], keyString, this.props.data.config, params, this);
    } else if (sessionStorage.getItem('product') === 'AutoCheck Insurance') {

      const params = {
        key: `requests/${this.props.data.person.locations[0].customerId}/${this.props.data.person.locations[0].locationId}/${this.props.data.person.personId}/${this.state.filesToUpload[0][0].name}`,
        bucket: `autotec-${getEnvironmentFromUrl()}-batch-process-reports`,
        method: 'POST'
      }

      const fields = {
        'x-amz-meta-reports': reportString,
        'x-amz-meta-autotecId': autotecId,
        'x-amz-meta-locationId': localStorage.getItem('locationId'),
        'x-amz-meta-customerId': this.props.data.customerInfo.customerId,
        'x-amz-meta-customerName': this.props.data.customerInfo.name,
        'x-amz-meta-personId': this.props.data.person.personId
      }

      if (reports.includes('RISK_SCORE')) {
        fields['x-amz-meta-score-predictor-model'] = this.state.predictorScoreModel;
      }
      if (reports.includes('RISK_PLUS')) {
        fields['x-amz-meta-score-plus-model'] = this.state.plusScoreModel;
      }

      params.fields = fields;

      this.props.actions.postPresignedUrl(this.state.filesToUpload[0],
        params, this.props.data.config, this);
    }

    if (this.state.masterData !== this.state.custReportData) {
      this.setState({ custReportData: this.state.masterData });
    }
    this.setState({ fileUploaded: true, fileUploadedMessage: '', reportFormat: 'HTML' });
    this.props.change('responseFormat', 'HTML');
    this.onlyCsv = false;
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleReportChange = (event) => {
    this.setState({ reportFormat: event.target.value });
  }

  loadAvailableReportsToState = () => {
    const menuOptions = [];
    let itemsForMenu = [];

    if (this.props.data.reportTypes &&
      this.props.data.reportTypes.reportTypes &&
      this.props.data.reportTypes.reportTypes.reportTypes) {
      this.props.data.reportTypes.reportTypes.reportTypes.forEach((rep) => {
        if (rep.availableForUi) {
          if (this.state.custReportData.includes(rep.methodId)
            && rep.productType.includes(this.state.products[sessionStorage.getItem('product')])
            && rep.enum !== 'NMVTIS' && rep.enum !== 'SUMMARY') {
            itemsForMenu.push(rep);
          }

          if (this.state.products[sessionStorage.getItem('product')] === 'ACA'
          && (rep.enum === 'DATA_EXISTS' || rep.enum === 'FIRST_LAST')
          && this.state.reportFormat.toLowerCase() === 'html') {
            itemsForMenu.splice(itemsForMenu.indexOf(rep.enum), 1);
          }
        }
      });
      itemsForMenu = sessionStorage.getItem('product') === 'AutoCheck Auctions' ? itemsForMenu.filter(rep => rep.enum !== 'VEHICLE_HISTORY') : itemsForMenu;
    }

    this.onlyCsv = itemsForMenu.length === 1 && itemsForMenu[0].methodId === '/vehicle/history/exists';
    
    itemsForMenu.sort((a, b) => {
      if (a.displayName.toLowerCase() > b.displayName.toLowerCase()) {
        return 1;
      }
      if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) {
        return -1;
      }
      return 0;
    })

    const scoreModelMenuOptions = [];

    if (this.props.data.reportTypes && this.props.data.reportTypes.reportTypes) {
      this.props.data.reportTypes.reportTypes.scoreModel.forEach((scoreModel) => {
        scoreModelMenuOptions.push(<MenuItem key={scoreModel} value={scoreModel}>{scoreModel}</MenuItem>);
      });
    }

    itemsForMenu.forEach((rep) => {
      if (sessionStorage.getItem('product') === 'AutoCheck Insurance') {
        menuOptions.push(<li key={rep.enum}
          style={{
            padding: '6% 0 3px 0',
            textAlign: 'left',
            fontSize: '12pt',
            font: 'Roboto',
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between'
          }}>
          <span>{rep.displayName}</span>
          {rep.displayName.includes('Risk') &&
            <Field name={rep.displayName} component={renderSelectField} label="*Score Model"
              className={this.props.classes.scoreModel}
              onChange={rep.displayName === 'Risk Plus Score' ? this.capturePlusScoreModel : this.capturePredictorScoreModel}
            >
              {scoreModelMenuOptions}
            </Field>
          }
          <span className="hover-close">
            <Remove
              style={{ float: 'right', height: '17px', width: '13.6px', alignItems: 'bottom' }}
              onClick={() => this.handleDelete(rep.methodId)}
            />
          </span>
        </li>);
      } else {
        menuOptions.push(<li key={rep.enum}
          className="reportHover"
          style={{
            cursor: 'pointer', padding: '4px 0 3px 0', textAlign: 'left', fontSize: '14pt', font: 'Roboto',
            display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'
          }}>
          {rep.displayName}
          <Remove
            style={{ float: 'right', height: '17px', width: '13.6px', alignItems: 'bottom' }}
            onClick={() => this.handleDelete(rep.methodId)}
          />
        </li>);
      }
    });

    return menuOptions;
  }

  capturePlusScoreModel = (event) => {
    this.setState({ plusScoreModel: event.target.value });
  }

  capturePredictorScoreModel = (event) => {
    this.setState({ predictorScoreModel: event.target.value });
  }

  render() {
    const { fileUploadedMessage, message, openDialog } = this.state;
    const { classes, initialValues } = this.props;
    let ReportsToRun = <div />;
    let dialog = <div />;


    if (message !== '') {
      dialog =
        (<RenderDialog
          open={openDialog}
          confirmButton
          message={message}
          onClose={this.handleClose}
        />)
    }

    ReportsToRun = (
      <div className={classes.reportToRunDiv}>
        <p className={classes.availableReportHeader}>Available Reports</p>
        <p className={classes.reportInstructions}><i>Remove any reports that you do not wish to receive.</i></p>
        {
          sessionStorage.getItem('product') === 'AutoCheck Auctions' &&
          <p className={classes.reportInstructions}><i>Data Exists and First Last Title reports are only available as CSV.</i></p>
        }
        <ul className={sessionStorage.getItem('product') === 'AutoCheck Insurance' ? classes.aciListOfReports : classes.listOfReports}>
          {this.loadAvailableReportsToState()}
        </ul>
      </div>
    );

    const reportValues = this.onlyCsv ? ['CSV'] : ['CSV', 'HTML'];
    if (this.onlyCsv) {
      this.props.change('responseFormat', 'CSV');
    }
    const reportItems = reportValues.map(rep => <MenuItem value={rep} key={rep}>{rep}</MenuItem>);

    let showCard = <div align="center"><CircularProgress size={75} /></div>;

    let fileUploadType = (
      <p style={{ color: 'rgba(168, 169, 174, 1)' }}>Valid file types: csv or txt</p>
    )

    if (!this.state.isFetching) {
      showCard = (
        <Form key="MultipleVINReportForm" onSubmit={this.handleSave}>
          <Card className={classes.card} style={{ height: 'auto' }}>
            <Grid container alignItems="center" className={classes.formDiv} justify="center">
              <Grid item md={12} lg={6} sm={12} xs={12}>
                <CardContent
                  className={classes.dropBoxArea}
                >
                  <ReactDropzone
                    onDrop={this.onDrop}
                    className="dropzone"
                  >
                    <div className={classes.availabeReportDiv}>
                      <img src={upload} alt="File Upload" width={100} height={67} />
                      <br /><br />
                      <p className={classes.dropBoxMessage}>Drag File Here or <span className={classes.dropBoxMessageSpan}>Browse</span></p>
                    </div>
                  </ReactDropzone>
                  <div style={{ height: '16px' }} className="fileUploadMsg">
                    { this.state.fileAttached ? fileUploadedMessage : fileUploadType }
                  </div>
                  <div style={sessionStorage.product === 'AutoCheck Insurance' ? { paddingTop: '10%', width: '200px', display: 'none' } : { paddingTop: '15%', width: '200px', margin: '0 auto' }}>
                    <Field
                      component={renderSelectField}
                      name="responseFormat"
                      onChange={this.handleReportChange}
                      className={classes.textField}
                      divClassName={classes.formControl}
                      children={reportItems}
                      placeholder={initialValues}
                    />
                  </div>
                  {sessionStorage.product === 'AutoCheck Auctions' && <p style={{ color: 'rgba(168, 169, 174, 1)' }}>*Response Format</p>}
                </CardContent>
              </Grid>
              {dialog}
              <Grid item md={12} lg={6} sm={12} xs={12}>
                <CardContent
                  className={classes.reportSelector}
                >
                  {ReportsToRun}
                </CardContent>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className={classes.buttonStyle}>
                  <Button
                    variant="raised"
                    disabled={!this.props.valid || !this.state.fileAttached }
                    style={this.props.valid && this.state.fileAttached ? { background: '#002053', cursor: 'pointer' } : { background: '#ddd' }}
                    type="submit">Submit</Button>
                  <div className={`${classes.messageStyle} mandatory-msg`}>* Required fields</div>
                </div>
              </Grid>
            </Grid>
          </Card>
        </Form >)
    } else {
      showCard = <div align="center"><CircularProgress size={75} /></div>;
    }
    return (
      <Layout className="App" showMenu menuTitle="Account Settings" leftTitle="Report Manager" rightTitle="Submit File" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727." >
        <Paper className={classes.paperStyle}>
          {showCard}
        </Paper>
      </Layout >
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    getPageData: async (config, self) => {
      self.setState({ fetching: true });
      // update reports types in redux (will access through mapStateToProps)
      await dispatch(getReportTypes(config));

      // get location record for the selected location (need location to get customer record)
      const locationId = localStorage.getItem('locationId');
      const locationResult = await dispatch(searchByAttribute('locations', 0, 'locationId', locationId, config));
      const location = optional(locationResult, ['value', 'data', 'items', 0], undefined);

      // get customer record for the selected location
      const { customerId } = location;
      const customerResult = await dispatch(searchByAttribute('customers', 0, 'customerId', customerId, config));
      const customer = optional(customerResult, ['value', 'data', 'items', 0], undefined);

      // update state
      self.setState({
        custReportData: customer.authorizedMethodIds,
        masterData: customer.authorizedMethodIds,
        isFetching: false
      });
    },
    postUrlFile: (acceptedFiles, keyString, config, params, self) => {
      self.setState({ isFetching: true });
      dispatch(postUrlFileUpload(acceptedFiles, keyString, params, config)).then((res) => {
        self.setState({ openDialog: true, fileAttached: false, isFetching: false, message: 'The file has been successfully uploaded.  You will receive the reports via email when ready.' });
      });
    },
    postPresignedUrl: (acceptedFiles, params, config, self) => {
      self.setState({ isFetching: true });
      dispatch(postPresignedUrl(acceptedFiles, params, config)).then((res) => {
        self.setState({ openDialog: true, fileAttached: false, isFetching: false, message: 'The file has been successfully uploaded.  You will receive the file via email when ready.' });
      }).catch((except) => {
        self.setState({ openDialog: true, fileAttached: false, isFetching: false, message: 'There was an error uploading the file.  Please try again.' });
      });
    }
  }
});

const mapStateToProps = (state, ownProps) => ({
  data: {
    addEditCustomer: state.addEditCustomer,
    addEditLocation: state.addEditLocation,
    customers: state.customers,
    customerGroups: state.customerGroups,
    reportTypes: state.reportTypes,
    locations: state.search.locations,
    config: state.config.config,
    error: state.error,
    cognitoId: state.login.login.sub,
    personId: state.person.person.personId,
    person: state.person.person,
    userLocations: state.userLocations.userLocations,
    customerInfo: state.search && state.search.customers && state.search.customers.data[0]
  },
  autotecId: state.person.person.locations.filter(loc => loc.locationId === localStorage.locationId)[0].autotecId,
  initialValues: {
    responseFormat: 'HTML',
  },
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'MultipleVINReportForm',
  enableReinitialize: true,
  validate
})(MultipleVINReport));

const ConnectedMultipleVINReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedMultipleVINReport;


// WEBPACK FOOTER //
// ./src/components/Account/MultipleVINReport.js